/*
 * GET INVOICES
 */
export const GET_INVOICES_BY_ADMIN = "GET_INVOICES_BY_ADMIN"
export const GET_INVOICES_BY_ADMIN_SUCCESS = "GET_INVOICES_BY_ADMIN_SUCCESS"
export const GET_INVOICES_BY_ADMIN_ERROR = "GET_INVOICES_BY_ADMIN_ERROR"

export const RESET_ERROR = "RESET_ERROR"

export const UPDATE_INVOICE_BY_ADMIN = "UPDATE_INVOICE_BY_ADMIN"
export const UPDATE_INVOICE_BY_ADMIN_SUCCESS = "UPDATE_INVOICE_BY_ADMIN_SUCCESS"
export const UPDATE_INVOICE_BY_ADMIN_ERROR = "UPDATE_INVOICE_BY_ADMIN_ERROR"

export const CREATE_RECEIPT_BY_ADMIN = "CREATE_RECEIPT_BY_ADMIN"
export const CREATE_RECEIPT_BY_ADMIN_SUCCESS = "CREATE_RECEIPT_BY_ADMIN_SUCCESS"
export const CREATE_RECEIPT_BY_ADMIN_ERROR = "CREATE_RECEIPT_BY_ADMIN_ERROR"

export const GET_BILLING_REPORT_BY_ADMIN = "GET_BILLING_REPORT_BY_ADMIN"
export const GET_BILLING_REPORT_BY_ADMIN_SUCCESS = "GET_BILLING_REPORT_BY_ADMIN_SUCCESS"
export const GET_BILLING_REPORT_BY_ADMIN_ERROR = "GET_BILLING_REPORT_BY_ADMIN_ERROR"

export const DELETE_INVOICE_BY_ADMIN = "DELETE_INVOICE_BY_ADMIN"
export const DELETE_INVOICE_BY_ADMIN_SUCCESS = "DELETE_INVOICE_BY_ADMIN_SUCCESS"
export const DELETE_INVOICE_BY_ADMIN_ERROR = "DELETE_INVOICE_BY_ADMIN_ERROR"


export const EDIT_INVOICE_BY_ADMIN = "EDIT_INVOICE_BY_ADMIN"
export const EDIT_INVOICE_BY_ADMIN_SUCCESS = "EDIT_INVOICE_BY_ADMIN_SUCCESS"
export const EDIT_INVOICE_BY_ADMIN_ERROR = "EDIT_INVOICE_BY_ADMIN_ERROR"

export const GET_INVOICE_EVENTS_BY_ID = "GET_INVOICE_EVENTS_BY_ID"
export const GET_INVOICE_EVENTS_BY_ID_SUCCESS = "GET_INVOICE_EVENTS_BY_ID_SUCCESS"
export const GET_INVOICE_EVENTS_BY_ID_ERROR = "GET_INVOICE_EVENTS_BY_ID_ERROR"

export const RESET_INVOICE_EVENTS_BY_ID = "RESET_INVOICE_EVENTS_BY_ID"

export const ROLLBACK_INVOICE_VERSION = "ROLLBACK_INVOICE_VERSION"
export const ROLLBACK_INVOICE_VERSION_SUCCESS = "ROLLBACK_INVOICE_VERSION_SUCCESS"
export const ROLLBACK_INVOICE_VERSION_ERROR = "ROLLBACK_INVOICE_VERSION_ERROR"
export const RESET_RECEIPT_TERMINAL_FORM = "RESET_RECEIPT_TERMINAL_FORM"

export const GET_RECEIPTS_INFO_BY_ADMIN = "GET_RECEIPTS_INFO_BY_ADMIN"
export const GET_RECEIPTS_INFO_BY_ADMIN_SUCCESS = "GET_RECEIPTS_INFO_BY_ADMIN_SUCCESS"
export const GET_RECEIPTS_INFO_BY_ADMIN_ERROR = "GET_RECEIPTS_INFO_BY_ADMIN_ERROR"